<template>
  <div class="l1">
    <div class="container">
      <div class="padding-mid">
        <div id="faq" class="repay-wrapper">
          <div>
            <div class="h2"><h1 class="h2-54-extrabold">How To Pay</h1></div>
          </div>
          <div class="repay-section">
            <div class="repay">
              <div role="list" class="faq-list">
                <div role="listitem" class="faq-item">
                  <div class="faq-wrapper">
                    <div class="faq-top">
                      <div class="faq-question-wrapper"><h2 class="h2-32">Gcash</h2></div>
                      <div :class="['faq-icon-wrapper', $style.iconWrapper]">
                        <div :class="['faq-icon', 'w-embed', $style.icon]">
                          <Icon name="material-symbols:chevron-left" size="32" />
                        </div>
                      </div>
                    </div>
                    <div :class="['faq-bottom', $style.faqBottom]">
                      <div :class="$style.repayAnswer">
                        <p>1. Log in to GCash</p>
                        <p>2. Click <strong>Bills</strong></p>
                        <img src="/images/how-to-repay/gcash-step1.png" alt="" loading="lazy" />
                        <p>3. Click <strong>Loans</strong></p>
                        <img src="/images/how-to-repay/gcash-step2.png" alt="" loading="lazy" />
                        <p>4. Choose <strong>Dragon Loans</strong></p>
                        <img src="/images/how-to-repay/gcash-step3.png" alt="" loading="lazy" />
                        <p>5. Fill out the following payment details</p>
                        <img src="/images/how-to-repay/gcash-step4.png" alt="" loading="lazy" />
                        <ul role="list">
                          <li>Reference Number – Your 8-digit PondoPinoy LifeTime ID.</li>
                          <li>Contact Number - Your Mobile number that you used to confirm yourPondoPinoy loan</li>
                          <li>Amount – payment amount</li>
                          <li>Then Click <strong>next</strong></li>
                        </ul>
                        <p>6. Click <strong>CONFIRM</strong></p>
                        <img src="/images/how-to-repay/gcash-step5.png" alt="" loading="lazy" />
                        <p></p>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style module>
.iconWrapper {
  color: rgb(255, 255, 255);
  background-color: rgb(61, 129, 29);
}

.icon {
  transform: rotateZ(90deg);
}

.faqBottom {
  opacity: 1;
}

.repayAnswer {
  padding-top: 1rem;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;

  img {
    max-width: 60%;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 767px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 479px) {
    font-size: 0.9rem;

    img {
      max-width: 100%;
    }
  }
}
</style>
